"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiReportPurchaseResponseDto = void 0;
const types_1 = require("../../../billing-api-order/types");
const types_2 = require("../../../billing-api-payment/types");
const swagger_1 = require("../../../../swagger-fake");
const billing_api_report_purchase_charge_reponse_dto_1 = require("./billing-api-report-purchase-charge-reponse.dto");
const types_3 = require("../../../billing-api-operation/types");
const class_transformer_1 = require("class-transformer");
class BillingApiReportPurchaseResponseDto {}
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сумма причитающаяся поставщику услуги",
  example: "1.72"
}), __metadata("design:type", String)], BillingApiReportPurchaseResponseDto.prototype, "supplierAmount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Сумма причитающаяся комиссионеру. Если комиссионеров несколько, то сумма по всем`,
  example: "0.90"
}), __metadata("design:type", String)], BillingApiReportPurchaseResponseDto.prototype, "brokerFee", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сведения об операции",
  type: () => types_3.BillingApiOperationResponseDto
}), (0, class_transformer_1.Type)(() => types_3.BillingApiOperationResponseDto), __metadata("design:type", types_3.BillingApiOperationResponseDto)], BillingApiReportPurchaseResponseDto.prototype, "operation", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сведения о сделке",
  type: () => types_1.BillingApiOrderResponseDto
}), (0, class_transformer_1.Type)(() => types_1.BillingApiOrderResponseDto), __metadata("design:type", types_1.BillingApiOrderResponseDto)], BillingApiReportPurchaseResponseDto.prototype, "order", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сведения о платеже",
  type: () => types_2.BillingApiPaymentResponseDto
}), (0, class_transformer_1.Type)(() => types_2.BillingApiPaymentResponseDto), __metadata("design:type", types_2.BillingApiPaymentResponseDto)], BillingApiReportPurchaseResponseDto.prototype, "payment", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Детализация по каждому начислению",
  type: () => billing_api_report_purchase_charge_reponse_dto_1.BillingApiReportPurchaseChargeResponseDto
}), (0, class_transformer_1.Type)(() => billing_api_report_purchase_charge_reponse_dto_1.BillingApiReportPurchaseChargeResponseDto), __metadata("design:type", Array)], BillingApiReportPurchaseResponseDto.prototype, "chargeInfo", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Суммарная комиссия овнера в валюте зачисления по всем оплаченным начислениям",
  example: "0.20"
}), __metadata("design:type", String)], BillingApiReportPurchaseResponseDto.prototype, "ownerFee", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Url плательщика у мерчанта"
}), __metadata("design:type", Object)], BillingApiReportPurchaseResponseDto.prototype, "customerMerchantLink", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Url продавца у мерчанта"
}), __metadata("design:type", Object)], BillingApiReportPurchaseResponseDto.prototype, "supplierMerchantLink", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Url платёжной операции у мерчанта"
}), __metadata("design:type", Object)], BillingApiReportPurchaseResponseDto.prototype, "operationMerchantLink", void 0);
exports.BillingApiReportPurchaseResponseDto = BillingApiReportPurchaseResponseDto;
